import videojs from 'video.js';

const Component = videojs.getComponent('Component');

class SkipButtons extends Component {
  constructor(player, options) {
    super(player, options);
  }

  createEl() {
    const el = videojs.dom.createEl('div', {
      className: 'vjs-skip-buttons',
      innerHTML: `
                    <div class="vjs-icon-replay-5 pr-[8px] lg:pr-[12px] cursor-pointer" id="replay-seek-button">
                            <img src="backward.svg" alt="">
                    </div>
                    <div class="vjs-icon-forward-5 cursor-pointer" id="forward-seek-button">
                            <img src="forward.svg" alt="">
                    </div>
                `
    });

    return el;
  }

  handleClick() {
    // console.log('heree');
  }
}

videojs.registerComponent('SkipButtons', SkipButtons);

export default SkipButtons;
